var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modalEquipaments',{attrs:{"equipmentsDTO":_vm.equipmentsWatchList,"details":_vm.item}})
}
var staticRenderFns = []

export { render, staticRenderFns }